// @ts-ignore
import { Scrollama, Step } from 'react-scrollama'
import { useState } from 'react'
import styled from 'styled-components'
import { useSpring, useTransition, animated, config } from '@react-spring/web'
import { device } from '../breakpoints'
import { Waypoint } from 'react-waypoint'
import { Strong } from '../styles'
import { circlesData, Circle } from './hemicycleData'
import TextWrap from '../TextWrap'

const texts = [
  ['Conseil national', 'aa'],
  ['Conseil national', '200 sièges'],
  ['Vaud', '19 sièges'],
  ['Genève', '12 sièges'],
  ['Romands', '52 sièges'],
  ['Zurich', '36 sièges'],
  ['', ''],
]

const Hemicycle = () => {
  const [selectedSlide, setSelectedSlide] = useState(1)
  const [scrollamaContainerRef, setScrollamaContainerRef] =
    useState<HTMLDivElement | null>(null)
  const imageTransition = useTransition(selectedSlide, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: config.molasses,
  })

  const textTransition = useTransition(selectedSlide, {
    from: { opacity: 0, translateY: 50, translateX: '-50%' },
    enter: { opacity: 1, translateY: 0, translateX: '-50%' },
    leave: { opacity: 0, translateY: -50, translateX: '-50%' },
    config: config.stiff,
  })

  const handleEnter = (step: any) => {
    console.log(step.data)

    setSelectedSlide(step.data)
  }

  const handleExit = (step: any) => {
    console.log('EXIT', step.data)
    if (step.data === 2 && step.direction === 'up') {
      setSelectedSlide(1)
    }
  }

  interface CircleWithKey extends Circle {
    key: number
    idType: number
  }

  const listWithKeys: CircleWithKey[] = circlesData.map((obj, index) => {
    return { key: index, ...obj }
  })

  const transitionConfigs = () => {
    return {
      duration: 200,
      clamp: true,
    }
  }

  const slidesCanton = new Map([
    ['vd', [1, 2, 4]],
    ['ge', [1, 3, 4, 6]],
    ['ro', [1, 4, 6]],
    ['zu', [1, 5, 6]],
    ['other', [1, 6]],
  ])

  const shownCantons = [...slidesCanton]
    .filter(([key, value]) => value.includes(selectedSlide))
    .map(([key, values]) => key)

  // const filteredList = listWithKeys.filter(l => slidesCanton[l.type].includes(selectedSlide))

  const circlesTransition = useTransition(
    listWithKeys.filter((l) => shownCantons.includes(l.type)),
    {
      // Each item has a unique key
      keys: (item) => item.key,
      // Apply an animation for items that are entering the list
      from: { time: 0 },
      enter: { time: 1 },
      // Apply an animation for items that are leaving the list
      leave: { time: 0 },
      // onDestroyed: (item: any) => {
      //   console.log('destroyed', item)
      // },
      config: transitionConfigs(),
    }
  )

  return (
    <Container
      onClick={() => {
        setSelectedSlide(selectedSlide + 1)
      }}
    >
      <SlidesContainer
        style={
          {
            // height: scrollamaContainerRef?.getBoundingClientRect().height,
          }
        }
      >
        <SlidesContent>
          <Slide>
            <ImageContainer>
              <HemicycleSvg
                xmlns='http://www.w3.org/2000/svg'
                viewBox='0 0 620.48 315.8'
              >
                <Hatch
                  id='diagonalHatch'
                  patternUnits='userSpaceOnUse'
                  width='2'
                  height='2'
                >
                  <path d='M0,0 l2,2' />
                </Hatch>
                <HatchGray
                  id='diagonalHatchGray'
                  patternUnits='userSpaceOnUse'
                  width='2'
                  height='2'
                >
                  <path d='M0,0 l2,2' />
                </HatchGray>
                <g transform='translate(10, 10)'>
                  {circlesData
                    .filter((v) =>
                      selectedSlide === 6 ? v.type !== 'vd' : true
                    )
                    .map((circle, index) => (
                      <SeatDisabled
                        cx={circle.cx}
                        cy={circle.cy}
                        r={circle.r}
                        key={`seat-grey-${index}`}
                      />
                    ))}

                  <Ghosts>
                    <GhostBack active={[3].includes(selectedSlide)}>
                      <path d='m14.78,206.7c-2.7,2.7-4.4,6.4-4.7,10.4-.2,2.6.2,5,1,7.2.2.5.1,1.1-.3,1.5-3.2,3.1-5.2,7.4-5.2,12.2,0,2.5.6,4.9,1.5,7,.2.5.1,1.1-.2,1.5-2.7,3-4.3,7-4.3,11.3,0,2.9.8,5.7,2.1,8.1.3.5.2,1.1-.1,1.6-2.7,3.5-4.1,8.1-3.4,13,1.1,7.4,7.2,13.3,14.7,14.1,5.5.6,10.6-1.4,14.1-4.9.5-.5,1.4-.5,1.9,0,3.1,3.1,7.3,5.1,12.1,5.1s9-1.9,12.1-5.1c.5-.5,1.4-.5,1.9,0,3.1,3.1,7.3,5.1,12.1,5.1s9-1.9,12.1-5.1c.5-.5,1.4-.5,1.9,0,3.1,3.1,7.3,5.1,12.1,5.1s9-1.9,12.1-5.1c.5-.5,1.4-.5,1.9,0,3.1,3.1,7.3,5.1,12.1,5.1s9-1.9,12.1-5.1c.5-.5,1.4-.5,1.9,0,3.3,3.4,8,5.4,13.1,5,8.2-.5,15-7,15.8-15.1.4-3.7-.4-7.2-2.1-10.1-.3-.5-.2-1.2.3-1.6,3.5-3.6,5.7-8.8,5.1-14.4-.8-7.7-6.8-14-14.4-15-2-.3-4-.2-5.8.2-.9.2-1.7-.5-1.7-1.4v-.1c0-9.3-7.6-16.9-16.9-16.9-.6,0-1.2,0-1.8.1l-1.5.3c-.5.1-1,.2-1.5.4-.1.5-.1,1-.2,1.5l-.9,2.7c-2.4,5.9-8.1,10-14.8,10-4.9,0-9.2-2.2-12.1-5.6l-.9-1.2c-.3-.4-.6-.8-.8-1.3-.3.4-.5.8-.9,1.2l-1.9,2.2c-2.8,2.6-6.6,4.2-10.7,4.2-8.8,0-16-7.2-16-16,0-.5,0-1,.1-1.4l.2-1.5c.1-.5.2-1,.3-1.5-.5.2-.9.3-1.4.4l-2.7.5h-1.2c-5,0-9.3-2.3-12.2-5.8l-.9-1c-.3-.4-.6-.8-.8-1.3-.3.4-.5.8-.8,1.2l-2.1,2.3c-2.8,2.6-6.6,4.1-10.7,4.1-6,0-11.2-3.3-13.9-8.2l-.7-1.2c-.2-.5-.4-.9-.5-1.4-.4.3-.8.5-1.3.8l-2.3,1.9Z' />
                    </GhostBack>
                    <GhostBack active={[5].includes(selectedSlide)}>
                      <path d='m213.95,178.22c0-8.82-7.18-16-16-16-3.68,0-7.07,1.26-9.77,3.36-.73-8.15-7.59-14.56-15.93-14.56-1.97,0-3.86.38-5.6,1.03,0-.01,0-.02,0-.03,0-8.82-7.18-16-16-16-.89,0-1.77.09-2.62.23.13-.83.22-1.67.22-2.53,0-8.82-7.18-16-16-16-.94,0-1.85.1-2.74.25.15-.86.24-1.75.24-2.65,0-8.82-7.18-16-16-16-.9,0-1.78.09-2.64.24.05-.27.09-.54.12-.82,8.08-.8,14.41-7.63,14.41-15.92,0-8.82-7.18-16-16-16-8.21,0-14.98,6.21-15.89,14.18-7.87.78-14.06,7.28-14.38,15.28-7.51,1.32-13.23,7.87-13.23,15.74,0,.17.02.33.03.49-6.95,1.74-12.12,8.02-12.12,15.51,0,.53.03,1.06.08,1.58-6.42,2.08-11.08,8.11-11.08,15.22,0,.92.1,1.82.25,2.7-5.83,2.39-9.95,8.12-9.95,14.8,0,1.33.18,2.61.49,3.84-5.31,2.61-8.99,8.05-8.99,14.36,0,1.73.29,3.4.8,4.97-4.77,2.77-8,7.93-8,13.83,0,2,.39,3.92,1.06,5.69-4.54,2.83-7.58,7.85-7.58,13.58,0,2.52.6,4.9,1.65,7.02-3.73,2.93-6.15,7.47-6.15,12.58,0,2.93.81,5.67,2.19,8.04-3.18,2.93-5.19,7.11-5.19,11.76,0,3.34,1.03,6.45,2.8,9.02-2.72,2.87-4.39,6.73-4.39,10.98,0,8.82,7.18,16,16,16,5.36,0,10.09-2.66,13-6.71,2.91,4.05,7.64,6.71,13,6.71s10.09-2.66,13-6.71c2.91,4.05,7.64,6.71,13,6.71s10.15-2.68,13.05-6.77c2.9,4.09,7.66,6.77,13.05,6.77s10.09-2.66,13-6.71c2.91,4.05,7.64,6.71,13,6.71s10.15-2.68,13.05-6.78c2.9,4.09,7.66,6.78,13.05,6.78,8.82,0,16-7.18,16-16,0-3.52-1.16-6.77-3.09-9.41,4.04-2.91,6.69-7.64,6.69-12.99,0-2.6-.64-5.05-1.74-7.23,5.52-2.53,9.36-8.09,9.36-14.54,0-1.81-.32-3.54-.87-5.16,6.31-2.15,10.87-8.11,10.87-15.14,0-1.01-.1-1.99-.28-2.95,7.53-1.3,13.28-7.86,13.28-15.75,0-.21-.02-.42-.03-.62,8.6-.25,15.53-7.31,15.53-15.98Z' />
                    </GhostBack>
                  </Ghosts>

                  {selectedSlide < 6 &&
                    listWithKeys
                      .filter((l) =>
                        (selectedSlide === 3
                          ? ['vd']
                          : ['vd', 'ge', 'ro']
                        ).includes(l.type)
                      )
                      .map((circle, index) => (
                        <SeatDisabled
                          cx={circle.cx}
                          cy={circle.cy}
                          r={circle.r}
                          key={`seat-grey-${index}`}
                        />
                      ))}

                  <Ghosts>
                    <Ghost active={[3].includes(selectedSlide)}>
                      <path d='m14.78,206.7c-2.7,2.7-4.4,6.4-4.7,10.4-.2,2.6.2,5,1,7.2.2.5.1,1.1-.3,1.5-3.2,3.1-5.2,7.4-5.2,12.2,0,2.5.6,4.9,1.5,7,.2.5.1,1.1-.2,1.5-2.7,3-4.3,7-4.3,11.3,0,2.9.8,5.7,2.1,8.1.3.5.2,1.1-.1,1.6-2.7,3.5-4.1,8.1-3.4,13,1.1,7.4,7.2,13.3,14.7,14.1,5.5.6,10.6-1.4,14.1-4.9.5-.5,1.4-.5,1.9,0,3.1,3.1,7.3,5.1,12.1,5.1s9-1.9,12.1-5.1c.5-.5,1.4-.5,1.9,0,3.1,3.1,7.3,5.1,12.1,5.1s9-1.9,12.1-5.1c.5-.5,1.4-.5,1.9,0,3.1,3.1,7.3,5.1,12.1,5.1s9-1.9,12.1-5.1c.5-.5,1.4-.5,1.9,0,3.1,3.1,7.3,5.1,12.1,5.1s9-1.9,12.1-5.1c.5-.5,1.4-.5,1.9,0,3.3,3.4,8,5.4,13.1,5,8.2-.5,15-7,15.8-15.1.4-3.7-.4-7.2-2.1-10.1-.3-.5-.2-1.2.3-1.6,3.5-3.6,5.7-8.8,5.1-14.4-.8-7.7-6.8-14-14.4-15-2-.3-4-.2-5.8.2-.9.2-1.7-.5-1.7-1.4v-.1c0-9.3-7.6-16.9-16.9-16.9-.6,0-1.2,0-1.8.1l-1.5.3c-.5.1-1,.2-1.5.4-.1.5-.1,1-.2,1.5l-.9,2.7c-2.4,5.9-8.1,10-14.8,10-4.9,0-9.2-2.2-12.1-5.6l-.9-1.2c-.3-.4-.6-.8-.8-1.3-.3.4-.5.8-.9,1.2l-1.9,2.2c-2.8,2.6-6.6,4.2-10.7,4.2-8.8,0-16-7.2-16-16,0-.5,0-1,.1-1.4l.2-1.5c.1-.5.2-1,.3-1.5-.5.2-.9.3-1.4.4l-2.7.5h-1.2c-5,0-9.3-2.3-12.2-5.8l-.9-1c-.3-.4-.6-.8-.8-1.3-.3.4-.5.8-.8,1.2l-2.1,2.3c-2.8,2.6-6.6,4.1-10.7,4.1-6,0-11.2-3.3-13.9-8.2l-.7-1.2c-.2-.5-.4-.9-.5-1.4-.4.3-.8.5-1.3.8l-2.3,1.9Z' />
                    </Ghost>
                    <Ghost active={[5].includes(selectedSlide)}>
                      <path d='m213.95,178.22c0-8.82-7.18-16-16-16-3.68,0-7.07,1.26-9.77,3.36-.73-8.15-7.59-14.56-15.93-14.56-1.97,0-3.86.38-5.6,1.03,0-.01,0-.02,0-.03,0-8.82-7.18-16-16-16-.89,0-1.77.09-2.62.23.13-.83.22-1.67.22-2.53,0-8.82-7.18-16-16-16-.94,0-1.85.1-2.74.25.15-.86.24-1.75.24-2.65,0-8.82-7.18-16-16-16-.9,0-1.78.09-2.64.24.05-.27.09-.54.12-.82,8.08-.8,14.41-7.63,14.41-15.92,0-8.82-7.18-16-16-16-8.21,0-14.98,6.21-15.89,14.18-7.87.78-14.06,7.28-14.38,15.28-7.51,1.32-13.23,7.87-13.23,15.74,0,.17.02.33.03.49-6.95,1.74-12.12,8.02-12.12,15.51,0,.53.03,1.06.08,1.58-6.42,2.08-11.08,8.11-11.08,15.22,0,.92.1,1.82.25,2.7-5.83,2.39-9.95,8.12-9.95,14.8,0,1.33.18,2.61.49,3.84-5.31,2.61-8.99,8.05-8.99,14.36,0,1.73.29,3.4.8,4.97-4.77,2.77-8,7.93-8,13.83,0,2,.39,3.92,1.06,5.69-4.54,2.83-7.58,7.85-7.58,13.58,0,2.52.6,4.9,1.65,7.02-3.73,2.93-6.15,7.47-6.15,12.58,0,2.93.81,5.67,2.19,8.04-3.18,2.93-5.19,7.11-5.19,11.76,0,3.34,1.03,6.45,2.8,9.02-2.72,2.87-4.39,6.73-4.39,10.98,0,8.82,7.18,16,16,16,5.36,0,10.09-2.66,13-6.71,2.91,4.05,7.64,6.71,13,6.71s10.09-2.66,13-6.71c2.91,4.05,7.64,6.71,13,6.71s10.15-2.68,13.05-6.77c2.9,4.09,7.66,6.77,13.05,6.77s10.09-2.66,13-6.71c2.91,4.05,7.64,6.71,13,6.71s10.15-2.68,13.05-6.78c2.9,4.09,7.66,6.78,13.05,6.78,8.82,0,16-7.18,16-16,0-3.52-1.16-6.77-3.09-9.41,4.04-2.91,6.69-7.64,6.69-12.99,0-2.6-.64-5.05-1.74-7.23,5.52-2.53,9.36-8.09,9.36-14.54,0-1.81-.32-3.54-.87-5.16,6.31-2.15,10.87-8.11,10.87-15.14,0-1.01-.1-1.99-.28-2.95,7.53-1.3,13.28-7.86,13.28-15.75,0-.21-.02-.42-.03-.62,8.6-.25,15.53-7.31,15.53-15.98Z' />
                    </Ghost>
                  </Ghosts>

                  <ShapeBck
                    visible={[2].includes(selectedSlide)}
                    d='m168.15,252.76c-.8-7.7-6.8-14-14.4-15-2-.3-4-.2-5.8.2-.9.2-1.7-.5-1.7-1.4v-.1c0-9.3-7.6-16.9-16.9-16.9-5.3,0-10,2.4-13.1,6.3-.5.6-1.5.7-2,.1-3.1-3.2-7.4-5.2-12.2-5.2s-9.2,2-12.3,5.3c-.5.6-1.5.6-2,0-3.1-3.4-7.5-5.5-12.5-5.5-1.1,0-2.2.1-3.2.3-.9.2-1.7-.5-1.7-1.4.2-1.9,0-4-.5-6-1.8-6.5-7.3-11.4-14-12.3-5.8-.8-11.1,1.4-14.7,5.2-.5.6-1.5.6-2,0-3.2-3.6-7.9-5.8-13.1-5.6-8.5.3-15.7,7.1-16.3,15.6-.2,2.6.2,5,1,7.2.2.5.1,1.1-.3,1.5-3.2,3.1-5.2,7.4-5.2,12.2,0,2.5.6,4.9,1.5,7,.2.5.1,1.1-.2,1.5-2.7,3-4.3,7-4.3,11.3,0,2.9.8,5.7,2.1,8.1.3.5.2,1.1-.1,1.6-2.7,3.5-4.1,8.1-3.4,13,1.1,7.4,7.2,13.3,14.7,14.1,5.5.6,10.6-1.4,14.1-4.9.5-.5,1.4-.5,1.9,0,3.1,3.1,7.3,5.1,12.1,5.1s9-1.9,12.1-5.1c.5-.5,1.4-.5,1.9,0,3.1,3.1,7.3,5.1,12.1,5.1s9-1.9,12.1-5.1c.5-.5,1.4-.5,1.9,0,3.1,3.1,7.3,5.1,12.1,5.1s9-1.9,12.1-5.1c.5-.5,1.4-.5,1.9,0,3.1,3.1,7.3,5.1,12.1,5.1s9-1.9,12.1-5.1c.5-.5,1.4-.5,1.9,0,3.3,3.4,8,5.4,13.1,5,8.2-.5,15-7,15.8-15.1.4-3.7-.4-7.2-2.1-10.1-.3-.5-.2-1.2.3-1.6,3.5-3.6,5.7-8.8,5.1-14.4Z'
                  />
                  <ShapeBck
                    visible={[3].includes(selectedSlide)}
                    d='m131.86,201.7c0-8.8-7.2-16-16-16-1.4,0-2.7.2-3.9.5.2-1.1.4-2.2.4-3.4,0-8.8-7.2-16-16-16-1.3,0-2.5.2-3.6.4.2-1.1.3-2.1.3-3.3,0-8.8-7.2-16-16-16-1.2,0-2.3.1-3.5.4.2-1,.3-2.1.3-3.1,0-8.8-7.2-16-16-16s-16,7.2-16,16c0,.9.1,1.8.2,2.7-5.9,2.4-10,8.1-10,14.8,0,1.3.2,2.6.5,3.8-5.3,2.6-9,8-9,14.4,0,1.7.3,3.4.8,4.9-4.7,2.8-7.9,7.9-7.9,13.8,0,8.8,7.2,16,16,16,5.7,0,10.8-3,13.6-7.6,2.8,4.8,7.9,8.1,13.9,8.1,1.9,0,3.7-.3,5.3-.9-.4,1.4-.6,2.8-.6,4.3,0,8.8,7.2,16,16,16,5.7,0,10.7-3,13.5-7.5,2.8,4.8,7.9,8,13.8,8,8.8,0,16-7.2,16-16,0-1.5-.2-2.9-.6-4.2,5.1-2.7,8.5-8,8.5-14.1Z'
                  />

                  <ShapeBck
                    visible={[4].includes(selectedSlide)}
                    d='m211.92,178.22c0-8.82-7.18-16-16-16-3.68,0-7.07,1.26-9.77,3.36-.73-8.15-7.59-14.56-15.93-14.56-1.97,0-3.86.38-5.6,1.03,0-.01,0-.02,0-.03,0-8.82-7.18-16-16-16-.89,0-1.77.09-2.62.23.13-.83.22-1.67.22-2.53,0-8.82-7.18-16-16-16-.94,0-1.85.1-2.74.25.15-.86.24-1.75.24-2.65,0-8.82-7.18-16-16-16-.9,0-1.78.09-2.64.24.05-.27.09-.54.12-.82,8.08-.8,14.41-7.63,14.41-15.92,0-8.82-7.18-16-16-16-8.21,0-14.98,6.21-15.89,14.18-7.87.78-14.06,7.28-14.38,15.28-7.51,1.32-13.23,7.87-13.23,15.74,0,.17.02.33.03.49-6.95,1.74-12.12,8.02-12.12,15.51,0,.53.03,1.06.08,1.58-6.42,2.08-11.08,8.11-11.08,15.22,0,.92.1,1.82.25,2.7-5.83,2.39-9.95,8.12-9.95,14.8,0,1.33.18,2.61.49,3.84-5.31,2.61-8.99,8.05-8.99,14.36,0,1.73.29,3.4.8,4.97-4.77,2.77-8,7.93-8,13.83,0,2,.39,3.92,1.06,5.69-4.54,2.83-7.58,7.85-7.58,13.58,0,2.52.6,4.9,1.65,7.02-3.73,2.93-6.15,7.47-6.15,12.58,0,2.93.81,5.67,2.19,8.04-3.18,2.93-5.19,7.11-5.19,11.76,0,3.34,1.03,6.45,2.8,9.02-2.72,2.87-4.39,6.73-4.39,10.98,0,8.82,7.18,16,16,16,5.36,0,10.09-2.66,13-6.71,2.91,4.05,7.64,6.71,13,6.71s10.09-2.66,13-6.71c2.91,4.05,7.64,6.71,13,6.71s10.15-2.68,13.05-6.77c2.9,4.09,7.66,6.77,13.05,6.77s10.09-2.66,13-6.71c2.91,4.05,7.64,6.71,13,6.71s10.15-2.68,13.05-6.78c2.9,4.09,7.66,6.78,13.05,6.78,8.82,0,16-7.18,16-16,0-3.52-1.16-6.77-3.09-9.41,4.04-2.91,6.69-7.64,6.69-12.99,0-2.6-.64-5.05-1.74-7.23,5.52-2.53,9.36-8.09,9.36-14.54,0-1.81-.32-3.54-.87-5.16,6.31-2.15,10.87-8.11,10.87-15.14,0-1.01-.1-1.99-.28-2.95,7.53-1.3,13.28-7.86,13.28-15.75,0-.21-.02-.42-.03-.62,8.6-.25,15.53-7.31,15.53-15.98Z'
                  />

                  <ShapeBck
                    visible={[5].includes(selectedSlide)}
                    d='m594.18,266.52c1.7-2.6,2.8-5.7,2.8-9,0-4.7-2-8.9-5.2-11.8,1.4-2.4,2.2-5.1,2.2-8,0-5.1-2.4-9.6-6.1-12.5,1-2.1,1.6-4.5,1.6-7,0-5.5-2.8-10.3-7-13.2.7-1.9,1.2-3.9,1.2-6,0-5.9-3.2-11-7.9-13.8.5-1.6.8-3.2.8-4.9,0-6.3-3.7-11.7-9-14.4.3-1.2.5-2.5.5-3.8,0-8.8-7.2-16-16-16-6.6,0-12.3,4-14.7,9.8-2.7-5.1-8-8.5-14.1-8.5-7,0-12.9,4.4-15.1,10.6-2.6-5.3-8.1-9-14.4-9-8.8,0-16,7.2-16,16,0,1,.1,2,.3,3-1.1-.2-2.1-.3-3.3-.3-8.8,0-16,7.2-16,16v.8c-1.5-.5-3.1-.7-4.7-.7-8.5,0-15.4,6.6-15.9,14.9-1.9-.8-4-1.3-6.2-1.3-8.8,0-16,7.2-16,16,0,7.1,4.6,13,10.9,15.2-.6,1.6-.9,3.4-.9,5.2,0,6.2,3.5,11.6,8.7,14.2-1.2,2.2-1.8,4.7-1.8,7.4,0,5.4,2.6,10.1,6.7,13-1.9,2.6-3.1,5.9-3.1,9.4,0,8.8,7.2,16,16,16,5.4,0,10.1-2.7,13-6.8,2.9,4.1,7.7,6.7,13,6.7s10.1-2.7,13-6.7c2.9,4.1,7.6,6.7,13,6.7s10.1-2.7,13-6.7c2.9,4.1,7.6,6.7,13,6.7s10.1-2.7,13-6.7c2.9,4.1,7.6,6.7,13,6.7s10.1-2.7,13-6.7c2.9,4.1,7.6,6.7,13,6.7,8.8,0,16-7.2,16-16,.1-4.5-1.6-8.3-4.3-11.2Z'
                  />
                </g>

                <g transform='translate(10, 10)'>
                  {circlesTransition((style, item, state: any) => {
                    const groupLength = listWithKeys.filter(
                      (v) => v.type === item.type
                    ).length
                    return (
                      <Seat
                        cx={item.cx}
                        cy={item.cy}
                        r={item.r}
                        style={{
                          opacity: style.time.to((v) => {
                            // if (item.key === 0) {
                            // console.log(`Element #${item.key}: ${v.toFixed(3)} (${Math.max(Math.min(v * items.length - item.key, 1), 0).toFixed(3)}) -> ${items.length}`)
                            // }
                            return Math.max(
                              Math.min(v * groupLength - item.idType, 1),
                              0
                            )
                          }),
                          transform: style.time.to(
                            (v) =>
                              `translate(50, 50) scale(${Math.max(
                                Math.min(v * groupLength - item.idType, 1),
                                0
                              )}) translate(-50, -50)`
                          ),
                        }}
                      >
                        {item.key}
                      </Seat>
                    )
                  })}
                  <DisabledShape
                    visible={[6].includes(selectedSlide)}
                    d='m144.23,235.17c-.18-1.2-1.35-1.97-2.53-1.69s-2.31.4-3.52.4c-4.82,0-9.13-2.17-12.02-5.58-1.04-1.23-2.91-1.13-3.83.19-2.85,4.1-7.58,6.79-12.95,6.79-4.83,0-9.15-2.17-12.04-5.59-.91-1.07-2.57-1.11-3.51-.07-3.28,3.61-8.2,5.69-13.59,5.05-7.03-.84-12.74-6.46-13.69-13.47-.2-1.45-.2-2.88-.02-4.24.15-1.14-.85-2.06-1.97-1.82-1.06.23-2.15.35-3.28.35-5.2,0-9.79-2.52-12.66-6.39-.76-1.02-2.32-1.04-3.11-.04-2.89,3.62-7.34,5.94-12.33,5.94-5.98,0-11.17-3.33-13.84-8.23-.64-1.16-2.23-1.42-3.13-.44-2.51,2.71-4.16,6.23-4.43,10.1-.2,2.6.2,5,1,7.2.2.5.1,1.1-.3,1.5-3.2,3.1-5.2,7.4-5.2,12.2,0,2.5.6,4.9,1.5,7,.2.5.1,1.1-.2,1.5-2.7,3-4.3,7-4.3,11.3,0,2.9.8,5.7,2.1,8.1.3.5.2,1.1-.1,1.6-2.7,3.5-4.1,8.1-3.4,13,1.1,7.4,7.2,13.3,14.7,14.1,5.5.6,10.6-1.4,14.1-4.9.52-.52,1.38-.52,1.9,0,3.1,3.1,7.3,5.1,12.1,5.1s9-1.9,12.1-5.1c.5-.5,1.4-.5,1.9,0,3.1,3.1,7.3,5.1,12.1,5.1s9-1.9,12.1-5.1c.5-.5,1.4-.5,1.9,0,3.1,3.1,7.3,5.1,12.1,5.1s9-1.9,12.1-5.1c.5-.5,1.4-.5,1.9,0,3.1,3.1,7.3,5.1,12.1,5.1s9-1.9,12.1-5.1c.5-.5,1.4-.5,1.9,0,3.3,3.4,8,5.4,13.1,5,8.2-.5,15-7,15.8-15.1.4-3.7-.4-7.2-2.1-10.1-.3-.5-.2-1.2.3-1.6,3.5-3.6,5.7-8.8,5.1-14.4-.13-1.24-.4-2.44-.78-3.59s-1.75-1.79-2.88-1.25c-2.04.97-4.33,1.52-6.74,1.52-7.9,0-14.4-6.59-15.55-14.31Z'
                  />

                  <Shape
                    visible={[2].includes(selectedSlide)}
                    d='m168.15,252.76c-.8-7.7-6.8-14-14.4-15-2-.3-4-.2-5.8.2-.9.2-1.7-.5-1.7-1.4v-.1c0-9.3-7.6-16.9-16.9-16.9-5.3,0-10,2.4-13.1,6.3-.5.6-1.5.7-2,.1-3.1-3.2-7.4-5.2-12.2-5.2s-9.2,2-12.3,5.3c-.5.6-1.5.6-2,0-3.1-3.4-7.5-5.5-12.5-5.5-1.1,0-2.2.1-3.2.3-.9.2-1.7-.5-1.7-1.4.2-1.9,0-4-.5-6-1.8-6.5-7.3-11.4-14-12.3-5.8-.8-11.1,1.4-14.7,5.2-.5.6-1.5.6-2,0-3.2-3.6-7.9-5.8-13.1-5.6-8.5.3-15.7,7.1-16.3,15.6-.2,2.6.2,5,1,7.2.2.5.1,1.1-.3,1.5-3.2,3.1-5.2,7.4-5.2,12.2,0,2.5.6,4.9,1.5,7,.2.5.1,1.1-.2,1.5-2.7,3-4.3,7-4.3,11.3,0,2.9.8,5.7,2.1,8.1.3.5.2,1.1-.1,1.6-2.7,3.5-4.1,8.1-3.4,13,1.1,7.4,7.2,13.3,14.7,14.1,5.5.6,10.6-1.4,14.1-4.9.5-.5,1.4-.5,1.9,0,3.1,3.1,7.3,5.1,12.1,5.1s9-1.9,12.1-5.1c.5-.5,1.4-.5,1.9,0,3.1,3.1,7.3,5.1,12.1,5.1s9-1.9,12.1-5.1c.5-.5,1.4-.5,1.9,0,3.1,3.1,7.3,5.1,12.1,5.1s9-1.9,12.1-5.1c.5-.5,1.4-.5,1.9,0,3.1,3.1,7.3,5.1,12.1,5.1s9-1.9,12.1-5.1c.5-.5,1.4-.5,1.9,0,3.3,3.4,8,5.4,13.1,5,8.2-.5,15-7,15.8-15.1.4-3.7-.4-7.2-2.1-10.1-.3-.5-.2-1.2.3-1.6,3.5-3.6,5.7-8.8,5.1-14.4Z'
                  />

                  <Shape
                    visible={[3].includes(selectedSlide)}
                    d='m131.86,201.7c0-8.8-7.2-16-16-16-1.4,0-2.7.2-3.9.5.2-1.1.4-2.2.4-3.4,0-8.8-7.2-16-16-16-1.3,0-2.5.2-3.6.4.2-1.1.3-2.1.3-3.3,0-8.8-7.2-16-16-16-1.2,0-2.3.1-3.5.4.2-1,.3-2.1.3-3.1,0-8.8-7.2-16-16-16s-16,7.2-16,16c0,.9.1,1.8.2,2.7-5.9,2.4-10,8.1-10,14.8,0,1.3.2,2.6.5,3.8-5.3,2.6-9,8-9,14.4,0,1.7.3,3.4.8,4.9-4.7,2.8-7.9,7.9-7.9,13.8,0,8.8,7.2,16,16,16,5.7,0,10.8-3,13.6-7.6,2.8,4.8,7.9,8.1,13.9,8.1,1.9,0,3.7-.3,5.3-.9-.4,1.4-.6,2.8-.6,4.3,0,8.8,7.2,16,16,16,5.7,0,10.7-3,13.5-7.5,2.8,4.8,7.9,8,13.8,8,8.8,0,16-7.2,16-16,0-1.5-.2-2.9-.6-4.2,5.1-2.7,8.5-8,8.5-14.1Z'
                  />
                  <Shape
                    visible={[4].includes(selectedSlide)}
                    d='m211.92,178.22c0-8.82-7.18-16-16-16-3.68,0-7.07,1.26-9.77,3.36-.73-8.15-7.59-14.56-15.93-14.56-1.97,0-3.86.38-5.6,1.03,0-.01,0-.02,0-.03,0-8.82-7.18-16-16-16-.89,0-1.77.09-2.62.23.13-.83.22-1.67.22-2.53,0-8.82-7.18-16-16-16-.94,0-1.85.1-2.74.25.15-.86.24-1.75.24-2.65,0-8.82-7.18-16-16-16-.9,0-1.78.09-2.64.24.05-.27.09-.54.12-.82,8.08-.8,14.41-7.63,14.41-15.92,0-8.82-7.18-16-16-16-8.21,0-14.98,6.21-15.89,14.18-7.87.78-14.06,7.28-14.38,15.28-7.51,1.32-13.23,7.87-13.23,15.74,0,.17.02.33.03.49-6.95,1.74-12.12,8.02-12.12,15.51,0,.53.03,1.06.08,1.58-6.42,2.08-11.08,8.11-11.08,15.22,0,.92.1,1.82.25,2.7-5.83,2.39-9.95,8.12-9.95,14.8,0,1.33.18,2.61.49,3.84-5.31,2.61-8.99,8.05-8.99,14.36,0,1.73.29,3.4.8,4.97-4.77,2.77-8,7.93-8,13.83,0,2,.39,3.92,1.06,5.69-4.54,2.83-7.58,7.85-7.58,13.58,0,2.52.6,4.9,1.65,7.02-3.73,2.93-6.15,7.47-6.15,12.58,0,2.93.81,5.67,2.19,8.04-3.18,2.93-5.19,7.11-5.19,11.76,0,3.34,1.03,6.45,2.8,9.02-2.72,2.87-4.39,6.73-4.39,10.98,0,8.82,7.18,16,16,16,5.36,0,10.09-2.66,13-6.71,2.91,4.05,7.64,6.71,13,6.71s10.09-2.66,13-6.71c2.91,4.05,7.64,6.71,13,6.71s10.15-2.68,13.05-6.77c2.9,4.09,7.66,6.77,13.05,6.77s10.09-2.66,13-6.71c2.91,4.05,7.64,6.71,13,6.71s10.15-2.68,13.05-6.78c2.9,4.09,7.66,6.78,13.05,6.78,8.82,0,16-7.18,16-16,0-3.52-1.16-6.77-3.09-9.41,4.04-2.91,6.69-7.64,6.69-12.99,0-2.6-.64-5.05-1.74-7.23,5.52-2.53,9.36-8.09,9.36-14.54,0-1.81-.32-3.54-.87-5.16,6.31-2.15,10.87-8.11,10.87-15.14,0-1.01-.1-1.99-.28-2.95,7.53-1.3,13.28-7.86,13.28-15.75,0-.21-.02-.42-.03-.62,8.6-.25,15.53-7.31,15.53-15.98Z'
                  />
                  <Shape
                    visible={[5].includes(selectedSlide)}
                    d='m594.18,266.52c1.7-2.6,2.8-5.7,2.8-9,0-4.7-2-8.9-5.2-11.8,1.4-2.4,2.2-5.1,2.2-8,0-5.1-2.4-9.6-6.1-12.5,1-2.1,1.6-4.5,1.6-7,0-5.5-2.8-10.3-7-13.2.7-1.9,1.2-3.9,1.2-6,0-5.9-3.2-11-7.9-13.8.5-1.6.8-3.2.8-4.9,0-6.3-3.7-11.7-9-14.4.3-1.2.5-2.5.5-3.8,0-8.8-7.2-16-16-16-6.6,0-12.3,4-14.7,9.8-2.7-5.1-8-8.5-14.1-8.5-7,0-12.9,4.4-15.1,10.6-2.6-5.3-8.1-9-14.4-9-8.8,0-16,7.2-16,16,0,1,.1,2,.3,3-1.1-.2-2.1-.3-3.3-.3-8.8,0-16,7.2-16,16v.8c-1.5-.5-3.1-.7-4.7-.7-8.5,0-15.4,6.6-15.9,14.9-1.9-.8-4-1.3-6.2-1.3-8.8,0-16,7.2-16,16,0,7.1,4.6,13,10.9,15.2-.6,1.6-.9,3.4-.9,5.2,0,6.2,3.5,11.6,8.7,14.2-1.2,2.2-1.8,4.7-1.8,7.4,0,5.4,2.6,10.1,6.7,13-1.9,2.6-3.1,5.9-3.1,9.4,0,8.8,7.2,16,16,16,5.4,0,10.1-2.7,13-6.8,2.9,4.1,7.7,6.7,13,6.7s10.1-2.7,13-6.7c2.9,4.1,7.6,6.7,13,6.7s10.1-2.7,13-6.7c2.9,4.1,7.6,6.7,13,6.7s10.1-2.7,13-6.7c2.9,4.1,7.6,6.7,13,6.7s10.1-2.7,13-6.7c2.9,4.1,7.6,6.7,13,6.7,8.8,0,16-7.2,16-16,.1-4.5-1.6-8.3-4.3-11.2Z'
                  />
                </g>
              </HemicycleSvg>

              {/* {imageTransition((style, i) => (<Image style={style} src={require(`./hemicycle-${i}.svg`)} alt='hémicycle' />))} */}
              {textTransition((style, i) => (
                <TextContainer style={style}>
                  <Title>{texts[i][0]}</Title>
                  {texts[i][1].length > 0 && <Seats>{texts[i][1]}</Seats>}
                </TextContainer>
              ))}
            </ImageContainer>
          </Slide>
        </SlidesContent>
      </SlidesContainer>

      {/* <Waypoint onEnter={(e) => {console.log(e)}}>
          <div>A</div>
        </Waypoint> */}

      <ScrollamaContainer ref={setScrollamaContainerRef}>
        <Scrollama offset={1} onStepEnter={handleEnter} onStepExit={handleExit}>
          <Step data={1}>
            <StepContainer>
              <StepContent>
                <TextWrap>
                  <p>
                    Avant de nous intéresser au poids de notre vote,
                    penchons-nous déjà sur le poids des cantons au Conseil
                    national. Parce que <strong>ma voix</strong> ne compte que
                    pour <strong>mon canton</strong>.
                  </p>
                </TextWrap>
              </StepContent>
            </StepContainer>
          </Step>
          <Step data={2}>
            <StepContainer>
              <StepContent>
                <TextWrap>
                  <p>
                    Au Conseil national, le nombre de sièges attribués à un
                    canton dépend de la taille de sa population. Le canton de{' '}
                    <strong>Vaud</strong> dispose de <Strong>19 sièges</Strong>.
                  </p>
                </TextWrap>
              </StepContent>
            </StepContainer>
          </Step>
          <Step data={3}>
            <StepContainer>
              <StepContent>
                <TextWrap>
                  <p>
                    Le canton de <strong>Genève</strong>, avec ses 200'000
                    habitants, dispose de <Strong>12 sièges</Strong>
                  </p>
                </TextWrap>
              </StepContent>
            </StepContainer>
          </Step>
          <Step data={4}>
            <StepContainer>
              <StepContent>
                <TextWrap>
                  <p>
                    Au total, les députés romands occupent{' '}
                    <Strong>52 sièges</Strong> sur les 200 que compte la chambre
                    basse.
                  </p>
                </TextWrap>
              </StepContent>
            </StepContainer>
          </Step>
          <Step data={5}>
            <StepContainer>
              <StepContent>
                <TextWrap>
                  <p>
                    À titre de comparaison, le canton le plus représenté est
                    Zurich, avec ses <Strong>36 conseillers nationaux</Strong>.
                  </p>
                </TextWrap>
              </StepContent>
            </StepContainer>
          </Step>
          <Step data={6}>
            <StepContainer>
              <StepContent>
                <TextWrap>
                  <p>
                    Alors que se serait-il passé si le canton de Vaud avait été exclu des votes lors de la dernières législature?                   
                  </p>
                </TextWrap>
              </StepContent>
            </StepContainer>
          </Step>
        </Scrollama>
      </ScrollamaContainer>
    </Container>
  )
}

const Container = styled.div`
  display: relative;
  // background: rgb(${({ theme }) => theme.grayColorLight});
`

const SlidesContainer = styled.div`
  transform: translateZ(0);
  backface-visibility: hidden;
  min-height: 100vh;
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 0;
`

const Ghosts = styled.g``

const Shape = styled.path<{ visible: boolean }>`
  opacity: ${(props) => (props.visible ? 1 : 0)};
  fill: rgba(${({ theme }) => theme.colorMain}, 0.25);
  fill: url(#diagonalHatch);
  stroke-width: 1;
  stroke: rgb(${({ theme }) => theme.colorMain});
  // stroke-dasharray: 3;
  stroke-linecap: round;
`

const ShapeBck = styled(Shape)`
  fill: #ffffff;
`

const DisabledShape = styled.path<{ visible: boolean }>`
  fill: url(#diagonalHatchGray);
  stroke-width: 1;
  stroke: rgb(${({ theme }) => theme.grayColorDark});
  opacity: ${(props) => (props.visible ? 1 : 0)};
  stroke-dasharray: 3;
  stroke-linecap: round;
`

const Seat = styled(animated.circle)`
  fill: rgb(${({ theme }) => theme.colorMain});
  // filter: drop-shadow(1px 1px 1px rgb(0 0 0 / 0.1));
  stroke: rgb(${({ theme }) => theme.colorMainDark});
  stroke-width: 1;
  z-index: 1;
`

const SeatDisabled = styled.circle`
  fill: rgb(${({ theme }) => theme.grayColorMedium});
  stroke: rgb(${({ theme }) => theme.grayColorDark});
  // filter: drop-shadow(1px 1px 1px rgb(0 0 0 / 0.1));
  stroke-width: 1;
`

const Ghost = styled.g<{ active: boolean }>`
  path {
    fill: url(#diagonalHatchGray);
    stroke: rgb(${({ theme }) => theme.grayColorDark});
    stroke-dasharray: 3;
    stroke-linecap: round;
    stroke-width: 1;
    opacity: ${(props) => (props.active ? 1 : 0)};
  }
`

const GhostBack = styled(Ghost)`
  path {
    fill: white;
  }
`

const SlidesContent = styled.div`
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
`

const HemicycleSvg = styled.svg`
  width: 100%;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    transform: rotate(90deg) scale(${window.innerHeight / window.innerWidth});
  }

  @media ${device.tablet}, @media ${device.laptop} {
    transform: rotate(0) scale(1);
  }
`

const Hatch = styled.pattern`
  rect {
    fill: #ffffff;
  }

  path {
    stroke: rgb(${({ theme }) => theme.colorMain});
    stroke-width: 0.25;
    line-cap: square;
  }
`

const HatchGray = styled.pattern`
  rect {
    fill: #ffffff;
  }

  path {
    stroke: rgb(${({ theme }) => theme.grayColorDark});
    stroke-width: 0.25;
    line-cap: square;
  }
`

const TextContainer = styled(animated.div)`
  position: absolute;
  bottom: 0;
  left: 50%;
  text-align: center;
  width: 300px;
`

const Slide = styled.div`
  display: flex;
  height: 100vh;
  justify-content: center;
  align-items: center;
  width: 100%;
`
const ImageContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 900px;
  // background: white;
  // border-radius: 20px;
  // border: 1px solid rgb(${({ theme }) => theme.grayColorMedium});
  // box-shadow: 0px 2px 10px rgba(5, 0, 56, 0.08);
  padding: 20px;
`

const Image = styled(animated.img)`
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
`

const ScrollamaContainer = styled.div`
  position: relative;
  margin-top: -25vh;
  z-index: 1;
`

const StepContainer = styled.div`
  position: relative;
  height: 80vh;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Title = styled.div`
  color: var(--text-color);
  font-size: 2em;
  margin-bottom: 0.5em;
`

const Seats = styled.div`
  color: white;
  font-size: 1.25em;
  background: rgb(${({ theme }) => theme.colorMain});
  display: inline-block;
  padding: 0.2em 0.5em;
  -webkit-font-smoothing: antialiased;
  border-radius: 5px;
`

const StepContent = styled.div`
  font-family: var(--font-serif);
  width: 100%;
  padding: 0 1em;
  line-height: 1.8;
  margin-bottom: calc(60vh - 2em);
  -webkit-font-smoothing: antialiased;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    max-width: auto;
    font-size: 0.95em;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    max-width: 600px;
    font-size: 1em;
  }
`

export default Hemicycle
